export interface TCandidate {
  value: string;
  valid: boolean;
}

export interface ICandidateInfo {
  name: TCandidate;
  email: TCandidate;
}

export enum LocalStorageKey {
  SendOTP = "send-otp",
  CandidateInfo = "candidate-info",
  CountdownTime = "countdown-time",
}
